import { SalesChannel } from '../enum';
import { AdditionalPageOptions, HeadlineData, HighlightBadgeData, Id, TariffBenefitData } from 'app/interface/AdditionalPageOptions';
import { areIdsEqual } from './validator';

export const getPageOptions = (): AdditionalPageOptions | undefined => (window as any).additionalPageOptions;

export const getSubscriptionBenefits = (subId: Id): TariffBenefitData[] => {
    return Object.values(getPageOptions()?.tariffBenefits[subId] || {});
};

export const getAdditionalLink = (subscriptionId: string, linkId: string) => {
    return getPageOptions()?.additionalLinks[linkId]?.[subscriptionId];
};

export const getHeadline = (salesChannel: SalesChannel, isFlex: boolean): HeadlineData | undefined => {
    const headlines = getPageOptions()?.headlines;

    if (isFlex) {
        return headlines?.flex;
    }

    switch (salesChannel) {
        case SalesChannel.YOUNG:
            return headlines?.young;
        default:
            return headlines?.consumer;
    }
};

export const getHighlightBadgeData = (salesChannel: SalesChannel, isFlex = false): HighlightBadgeData | undefined => {
    const badges = getPageOptions()?.highlightBadges;
    const text = isFlex ? badges?.flex : { text: '' };

    switch (salesChannel) {
        case SalesChannel.YOUNG:
            return badges?.young;
        case SalesChannel.FF:
            return badges?.ff;
        default:
            return text;
    }
};

export const getSubscriptionIds = (): string[] => {
    const ids = getPageOptions()?.subscriptions || {};

    return Object.values(ids).map(id => id.toString());
};

export const getProductIds = (): string[] => {
    const ids = getPageOptions()?.hardwares || {};

    return Object.values(ids).map(id => id.toString());
};

export const getDiscountIds = (salesChannel: SalesChannel): string[] => {
    const discountIds = getPageOptions()?.discountIds[salesChannel] || {};

    return Object.values(discountIds).map(id => id.toString());
};

export const isFlexId = (id?: Id) => areIdsEqual(getPageOptions()?.flexId, id);

export const is5g = (id?: Id) => areIdsEqual(getPageOptions()?.gigacube5gId, id);

export const getHotlineNumbers = () => Object.values(getPageOptions()?.tracking?.hotlineNumber || {});

export default getPageOptions;
